export function initNewsletter(form: HTMLFormElement) {

	if (!form) {
		return;
	}


	ajaxifyNewsletterForm(form);


}

function ajaxifyNewsletterForm(form: HTMLFormElement) {
	let $form = $(form);

	if ($form.length) {
		$($form)['ajaxify']({
			history: false,
			refresh: [
				'[data-snippet="newsletter"]'
			],
			// onFinish: () => ajaxifyNewsletterForm(form),
		});
	}

}
